import { useEffect, useState } from 'react';
import './LanguageSwitcher.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import { useLang } from '../../context/languageContext';

function getCookie(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : null;
}

function setCookie(name, value) {
  document.cookie = `${name}=${value};path=/;domain=${window.location.hostname}`;
}

function clearCookie(name) {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}

function LanguageSwitcher() {
  const { availableLanguages } = useLang();
  const navigate = useNavigate();
  const location = useLocation();

  const [language, setLanguage] = useState('en');
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    let lang = urlParams.get('lang');

    if (!lang || !availableLanguages.includes(lang)) {
      lang = 'en';

      urlParams.set('lang', 'en');
      navigate(`${location.pathname}?${urlParams.toString()}`, { replace: true });
    }

    const cookieVal = getCookie('googtrans');
    const currentCookieLang = cookieVal ? cookieVal.split('/')[2] : 'en';

    if (lang !== currentCookieLang) {
      if (lang === 'en') {
        clearCookie('googtrans');
      } else {
        setCookie('googtrans', `/en/${lang}`);
      }

      if (!initialized) {
        setInitialized(true);
        window.location.reload();
        return;
      }
    }

    setLanguage(lang);
  }, [location.search, availableLanguages, initialized, navigate, location.pathname]);

  const handleLangChange = (e) => {
    const lang = e.target.value;
    setLanguage(lang);

    if (lang === 'en') {
      clearCookie('googtrans');
    } else {
      setCookie('googtrans', `/en/${lang}`);
    }

    navigate(location.pathname + '?lang=' + lang, { replace: true });

    window.location.reload();
  };

  return (
    <>
      <div id="google_translate_element"></div>
      <select
        id="language-toggle"
        className="skiptranslate"
        value={language}
        onChange={handleLangChange}
      >
        {availableLanguages.map((lang, index) => (
          <option key={index} value={lang}>
            {lang}
          </option>
        ))}
      </select>
    </>
  );
}

export default LanguageSwitcher;
